module.exports = __webpack_public_path__ + "static/media/lokalni.ea09e7e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/lokalni.jpg
// module id = 353
// module chunks = 0